export default __webpack_public_path__ + "static/vision-c9c65a7accd9b5fe80b77555148e6578.webp";